import { formatPrice, truncatePrice } from "./currency.js";
import { formatDate, formatLongDate, formatMonthDate } from "./time.js";
import { I18nProvider, I18nContext, I18n } from "./i18n.js";
import { canRunAdsFirefox } from './canRunAdsFirefox.js';
import { CookieCompliance, CookieComplianceCategories } from "./optanon.js";
import { Config, ConfigProvider } from "./config.js";
import { redirect, url, getQueryParams } from "./url.js";
import { copy } from "./copy.js";
import { canRunAds } from "./ads.js";
import { escapeRegExp, removeUrlFilterRegExp, replaceUrlFiltersRegExp } from "./regex.js";
import { isMobileDevice, isApplePayAvailable, isAppleDevice } from "./browser.js";
import { shuffleArray } from './shuffle.js';
import { windowPopUp } from './windowPopUp.js';
import { scrollToTop } from './scrollTop.js';
import jsonp from "./jsonp.js";
import { chunkArray } from "./chunkArray.js";
import { decode } from "./base64.js";
import Cookies, { getCookie, setCookie } from "./cookies.js";
import { getDevice, DeviceType } from "./devices.js";
import { StockLabel, getStockByStockLabel } from "./stock.js";
import { getCustomerValues, setCustomerValues, getInputError, getFormErrors, Validate } from './validate.js';

export {
    // currency.js
    formatPrice,
    truncatePrice,
    // time.js
    formatDate,
    formatLongDate,
    formatMonthDate,
    // i18n.js
    I18nProvider,
    I18nContext,
    I18n,
    // config.js
    Config,
    ConfigProvider,
    // copy.js
    copy,
    // url.js
    redirect,
    url,
    getQueryParams,
    // ads.js
    canRunAds,
    jsonp,
    // regex.js
    escapeRegExp,
    removeUrlFilterRegExp,
    replaceUrlFiltersRegExp,
    // browser.js
    isMobileDevice,
    isApplePayAvailable,
    isAppleDevice,
    shuffleArray,
    // cookies.js
    CookieCompliance,
    CookieComplianceCategories,
    windowPopUp,
    scrollToTop,
    canRunAdsFirefox,
    chunkArray,
    decode,
    Cookies,
    getCookie,
    setCookie,
    getDevice,
    DeviceType,
    //stock.js
    StockLabel,
    getStockByStockLabel,
    getCustomerValues,
    setCustomerValues,
    getInputError,
    getFormErrors,
    Validate,
};
